import { gozokiApiWithAuth } from '../gozokiApi'
import type { SensorAlertCategory } from '../queries/sensorAlertSettings.queries'

export interface UpdateAlertSettingsPayload {
  tempMin: number
  tempMax: number
  breachToleranceMinutes: number
  inactivityThresholdMinutes: number
}

export const updateAlertSettings = async (
  category: SensorAlertCategory,
  data: UpdateAlertSettingsPayload,
) => {
  const response = await gozokiApiWithAuth.patch(`/sensors/alert-settings/${category}`, data)
  return response.data
}
